import { useEffect, useState } from "react";
import { Search, Filter, Plus, X } from "lucide-react";
import { useDebounce } from "../hooks/useDebounce";


interface Props {
  title: string;
  showImport: boolean;
  showFilter: boolean;
  showAdd: boolean;
  onAdd?: () => void;

  // BARU: search
  showSearch: boolean;
  onSearch?: (value: string) => void;
  searchPlaceholder?: string;
  filterContent?: React.ReactNode;
}

export default function TableToolbar({
  title,
  showImport,
  showFilter,
  filterContent,
  showAdd,
  onAdd,
  showSearch,
  onSearch,
  
  searchPlaceholder = "Search...",
}: Props) {
  const [searchInput, setSearchInput] = useState("");
  const debouncedSearch = useDebounce(searchInput, 400);
  const [openFilter, setOpenFilter] = useState(false);

  // Kirim ke parent cuma setelah user berhenti mengetik 400ms,
  // dan cuma kalau onSearch memang disediakan (search tetap optional).
  useEffect(() => {
   
    onSearch?.(debouncedSearch.trim());
  }, [debouncedSearch]);

  const handleClear = () => {
    setSearchInput("");
  };

  useEffect(() => {
    onSearch?.(debouncedSearch.trim());
  }, [debouncedSearch]);

  return (
    <div className="flex justify-between items-center p-6">
      <h2 className="text-3xl font-bold">{title}</h2>

      <div className="flex gap-2">
        {showSearch && (
          <div className="relative">
            <Search
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            />

            <input
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder={searchPlaceholder}
              className="h-11 w-72 rounded-xl border border-gray-300 pl-10 pr-10 text-sm shadow-sm transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
            />

            {searchInput !== "" && (
              <button
                onClick={handleClear}
                aria-label="Clear search"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                <X size={16} />
              </button>
            )}
          </div>
        )}

        {showFilter && (
          <div className="relative">
            <button
              onClick={() => setOpenFilter((prev) => !prev)}
              className="flex h-11 items-center gap-2 rounded-xl border border-gray-300 bg-white px-4 text-sm font-medium text-gray-700 shadow-sm transition hover:bg-gray-50 hover:border-gray-400">
              <Filter size={18} />
              Filter
            </button>

            {openFilter && (
              <div className="absolute right-0 mt-2 w-80 rounded-xl border bg-white shadow-lg p-4 z-50">
                {filterContent}
              </div>
            )}
          </div>
        )}

        {showAdd && (
          <button
            onClick={onAdd}
            className="flex h-11 items-center gap-2 rounded-xl bg-blue-600 px-5 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700">
            <Plus size={18} />
            Add
          </button>
        )}
      </div>
    </div>
  );
}
